import {PlayArrowRounded, SkipNextRounded, SkipPreviousRounded, Pause} from '@mui/icons-material';
import * as PropTypes from "prop-types";
import styled from "styled-components";
import {useContext} from "react";
import {AudioPlayerContext} from "./AudioPlayerContext";

function PlayerControls() {
  const { isPlaying, play, prev, next} = useContext(AudioPlayerContext);

  return <ControlsWrapper>
    <PlayerButton onClick={prev}>
      <SkipPreviousRounded fontSize="inherit"/>
    </PlayerButton>
    <PlayerButton onClick={play}>
      {isPlaying ? <Pause fontSize="inherit"/> : <PlayArrowRounded fontSize="inherit"/>}
    </PlayerButton>
    <PlayerButton onClick={next}>
      <SkipNextRounded fontSize="inherit"/>
    </PlayerButton>
  </ControlsWrapper>;
}

PlayerControls.propTypes = {
  play: PropTypes.func,
  playing: PropTypes.bool
};

export default PlayerControls;

const ControlsWrapper = styled.div`
  display: flex;
  gap: 1rem;
  flex-shrink: 0;
`
const PlayerButton = styled.button`
  width: 12px;
  height: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  color: #423F67;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  font-size: 24px;
`;
